import React, { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Typewriter } from "react-simple-typewriter";
import { useNavigate, useLocation } from "react-router-dom";
import Carousel from "../Components/Carousel";
import Navbar from "../Components/Navbar";
import About from "../Components/About";
import Faqs from "../Components/Faqs";
import backgroundImage from "../Assets/background10.png";
import Chatbot from "../Pages/chatbot"; 
import styled from "styled-components";

const HomePage = () => {
  const homeSectionRef = useRef(null);
  const aboutSectionRef = useRef(null);
  const faqsSectionRef = useRef(null);
  const [activeSection, setActiveSection] = useState("home");
  const navigate = useNavigate();
  const location = useLocation();

  const updateActiveSection = (section) => setActiveSection(section);

  const scrollToSection = (ref, section) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: section } });
    } else {
      ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      updateActiveSection(section);
    }
  };

  useEffect(() => {
    if (location.state?.scrollTo) {
      const section = location.state.scrollTo;
      const refMap = { home: homeSectionRef, about: aboutSectionRef, faqs: faqsSectionRef };
      refMap[section]?.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      updateActiveSection(section);
    }
  }, [location]);

  return (
    <div>
      <FixedContainer>
        <Navbar
          activeSection={activeSection}
          onHomeClick={() => scrollToSection(homeSectionRef, "home")}
          onMarketplaceClick={() => navigate("/marketplace")}
          onAboutClick={() => scrollToSection(aboutSectionRef, "about")}
          onFaqsClick={() => scrollToSection(faqsSectionRef, "faqs")}
        />

        {/* HERO SECTION */}
        <HeroSection ref={homeSectionRef}>
          <Overlay />
          <HeroContent>
          <HeroText>
  <motion.h1
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 1, ease: "easeOut" }}
  >
    <Typewriter
      words={["Nature’s Best, Right at Your Doorstep"]}
      loop={0} // infinite loop
      cursor
      cursorStyle="|"
      typeSpeed={70}
      deleteSpeed={50} // enable deletion
      delaySpeed={200} // pause before deleting
    />
  </motion.h1>
</HeroText>

            <CarouselWrapper bgColor="#fff"> 
              <Carousel />
            </CarouselWrapper>
          </HeroContent>
        </HeroSection>

        {/* ABOUT SECTION */}
        <About ref={aboutSectionRef} />

        {/* FAQ SECTION */}
        <Faqs ref={faqsSectionRef} />

        {/* Add Chatbot to the homepage */}
        <Chatbot /> {/* Chatbot component here */}
      </FixedContainer>
    </div>
  );
};

export default HomePage;

/* STYLED COMPONENTS */

const FixedContainer = styled.div`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
`;

const HeroSection = styled.section`
  min-height: 100vh;
  background-image: url(${backgroundImage});
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 100px;
  box-sizing: border-box;
`;


const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 1;
`;

const HeroContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1200px;
  z-index: 2;
  padding: 0 40px;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

/* Animated Hero Text */
const HeroText = styled.div`
  max-width: 500px;

  h1 {
    font-size: 3rem;
    font-weight: bold;
    color: white;
    text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
    line-height: 1.3;
    margin-bottom: 20px;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 2rem;
    }
  }
`;

const CarouselWrapper = styled.div`
  max-width: 600px;
  margin-left: -50px;
  background-color: ${(props) => props.bgColor || "#fff"}; /* Use prop or default */

  @media (max-width: 768px) {
    max-width: 100%;
    margin-top: 20px;
  }
`;
